import { createNoopStorage, createWebStorage } from './utils';

// Workaround for failing to create sync storage.
// More about workaround: https://github.com/vercel/next.js/discussions/15687#discussioncomment-45319
export const createStorage = () => {
    if (typeof window === 'undefined') return createNoopStorage();
    return createWebStorage('local');
};
